module.exports = __webpack_public_path__ + "static/media/DSC_2325.7a315338.jpg";